import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import ScrollToTopFab from '../components/ScrollToTopFab'

// import { Header, Button, Sidebar, Menu, Segment, Icon } from 'semantic-ui-react';
import './index.css'

class PageContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
  }

  componentDidMount(){
    // let gtag = window.gtag
    // if (gtag !== undefined) {
    //   window.dataLayer = window.dataLayer || [];
    //   function gtag(){dataLayer.push(arguments);}
    //   gtag('js', new Date());

    //   gtag('config', 'UA-114682619-1');
    // }
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  render() {
    const { visible } = this.state;
    return (
      <div>
        <Helmet
          title="Mayad Post Production House"
          meta={[
            { name: 'description', content: 'Welcome to Mayad Post-Production House, your trusted co-author and editor in imagining and crafting a classic memento that will last for a lifetime - a wedding film that shares the anthology of your love to the world.' },
            { name: 'keywords', content: 'wedding, mayad , mayadpost, video, photo' },
          ]}
        >
          <link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet" />
          <link href="https://fonts.googleapis.com/css?family=Varela+Round" rel="stylesheet" />
          <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.12/semantic.min.css" />
          <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
          <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
          <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
          <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
          <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
          <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
          <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
          <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
          <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
          <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
          <link rel="icon" type="image/png" sizes="192x192" href="/android-icon-192x192.png" />
          <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
          <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
          <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
          <link rel="manifest" href="/manifest.json" />
          <meta property="og:url" content="http://mayadpostprod.com/" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Mayad Post Production House" />
          <meta property="og:description" content="We help wedding filmmakers from around the world manage their post-production needs." />
          <meta property="og:image" content={require('../assets/img/social-card.png')} />
          <meta name="msapplication-TileColor" content="#ffffff" />
          <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
          <meta name="theme-color" content="#ffffff" />
          <script type="text/javascript" src="https://cdn.emailjs.com/dist/email.min.js" />
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-114682619-1" />
        </Helmet>
        <div>

        </div>
        <div>
          <ScrollToTopFab />
          {this.props.children()}
        </div>
        {/* <Sidebar.Pushable>
          <Sidebar as={Menu} animation='overlay' direction='top' visible={visible} inverted>
            <Menu.Item name='home'>
              <Icon name='home' />
              Home
            </Menu.Item>
            <Menu.Item name='gamepad'>
              <Icon name='gamepad' />
              Games
            </Menu.Item>
            <Menu.Item name='camera'>
              <Icon name='camera' />
              Channels
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>

          </Sidebar.Pusher>
        </Sidebar.Pushable> */}
      </div>
    )
  }
}

const TemplateWrapper = ({ children }) => (
  <div>
    <PageContent children={children} />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js